import React, {Component} from 'react';
import PlanPortfolio from '../../components/PlanPortfolio/PlanPortfolio';
import PlanWealth from '../../components/PlanWealth/PlanWealth';
import PlanAllocation from '../../components/PlanAllocation/PlanAllocation';
import Conditions from '../../containers/Conditions/Conditions';
import {connect} from 'react-redux';
import {getIndexProtectorLabel} from "../../shared/common";
import * as actionTypes from '../../store/actions';
import * as actionCreators from '../../store/actionCreators';
import classes from './PlanOutput.css';
import ScrollToTopOnMount from '../ScrollToTopOnMount/ScrollToTopOnMount';
import ToolTip from '../ToolTip/ToolTip';
import PageHeader from '../../components/PageHeader/PageHeader';

export const CONDITIONS_STATE_MARKET = "CONDITIONS_STATE_MARKET";
export const CONDITIONS_STATE_NONE = "CONDITIONS_STATE_NONE";


export class PlanOutput extends Component {

    state = {
        editMode: false
    };

    componentDidMount() {
        if (this.props.updateMenuState)
            this.props.updateMenuState();
        this.props.clearPlanSubmit();
    }


    updateMarketConditions = (marketType) => {
        let isMarket = (marketType === CONDITIONS_STATE_MARKET);
        this.props.updateMarketConditionsType(isMarket);
    };

    updateIP7EditMode = () => {
        // let newState = Object.assign({}, this.state);
        // newState.editMode = !newState.editMode;
        // this.setState(newState);
        //
        // if (newState.editMode) {
        //     this.props.setIP7EditMode();
        // } else {
        //     this.props.validateIP7Allocations();
        //     this.props.updateIP7PlanCalculations();
        // }
        this.props.history.goBack();
    };

    cancelIP7Changes = () => {
        let newState = Object.assign({}, this.state);
        newState.editMode = false;
        this.setState(newState);

        this.props.cancelIP7Changes();
    };

    viewReport = () => {
        this.props.validateIP7Allocations();
        this.props.history.push("/reportBuilder");
    };

    calculate = () => {
        this.props.updateMarketRisk();
    };

    render() {

        let conditionsInputs = null;
        let editAllocationControls = null;
        let validationMessage = null;
        let viewReportBtn = null;

        let sixYearCumulativeWealthToolTip = null;
        let tenYearCumulativeWealthToolTip = null;
        let standardDevToolTip = null;
        let percentile10ToolTip = null;
        let percentile50ToolTip = null;
        let percentile90ToolTip = null;

        let sharpeRatioToolTip = null;
        let sortinoRatioToolTip = null;

        let instructionalText = null;

        let informationalMessage = null;

        if (!this.props.displayMode) {

            instructionalText = this.props.indexProtector.indexOf("INDEX ACHIEVER") === -1 ?
                (
                    <div className={classes.instructionMsg}>
                        <p>
                            The following information compares how the portfolio performs over a 10-year period with and without the {getIndexProtectorLabel(this.props.indexProtector)}. Additionally, you can see how the portfolio reallocates when the {getIndexProtectorLabel(this.props.indexProtector)} is added.
                        </p>
                        <p>
                            You can adjust the market conditions at the bottom of the page to further analyze the impact of adding the fee-based annuity.
                        </p>
                    </div>
                ) :
                (
                    <div className={classes.instructionMsg}>
                        <p>
                            The following table summarizes the results of the Monte Carlo simulations that were generated based on your selections. The following information compares how the portfolio performs over a 10-year period with and without the {getIndexProtectorLabel(this.props.indexProtector)}. Additionally, you can see how the portfolio reallocates when the {getIndexProtectorLabel(this.props.indexProtector)} is added. Review the allocation and market condition assumptions below, then refer to the Simulation Highlights to analyze the projected impact of {getIndexProtectorLabel(this.props.indexProtector)} on portfolio performance.
                        </p>
                        <p>
                            You can adjust the market conditions at the bottom of the page to further analyze the impact of adding the fee-based annuity.  If you would like to change the purchase payment or allocations you entered, you can select "Back to Introduction" above.
                        </p>
                        <p style={{fontWeight: "bold"}}>
                            IMPORTANT: The projections or other information generated by WealthCentral regarding the likelihood of various investment outcomes are hypothetical in nature, do not reflect actual investment results and are not guarantees of future results.
                        </p>
                    </div>
                );

            sixYearCumulativeWealthToolTip = (
                <ToolTip
                    includeHtmlTag={true}
                    message="The 90th Percentile figure in each column was extracted from the simulation whose 6-year value is exceeded by the relevant 6-year value in only 10% of all of the other simulations.<br/>
                            The 50th Percentile figure in each column was extracted from the simulation whose 6-year value is exceeded by the relevant 6-year value in 50% of all of the other simulations.<br/>
                            The 10th Percentile figure in each column was extracted from the simulation whose 6-year value is exceeded by the relevant 6-year value in 90% of all of the other simulations.<br/>
                            As a result, returns appearing in the same row below may have been extracted from different simulations."
                />
            );

            tenYearCumulativeWealthToolTip = (
                <ToolTip
                    includeHtmlTag={true}
                    message="The 90th Percentile figure in each column was extracted from the simulation whose 10-year value is exceeded by the relevant 10-year value in only 10% of all of the other simulations.<br/>
                            The 50th Percentile figure in each column was extracted from the simulation whose 10-year value is exceeded by the relevant 10-year value in 50% of all of the other simulations.<br/>
                            The 10th Percentile figure in each column was extracted from the simulation whose 10-year value is exceeded by the relevant 10-year value in 90% of all of the other simulations.<br/>
                            As a result, returns appearing in the same row below may have been extracted from different simulations."
                />
            );

            standardDevToolTip = (
                <ToolTip
                    message="Standard deviation is the measure of how much the set of simulated returns varies from its average return.  A set of returns with a high standard deviation is more dispersed from its average, while a set of returns with a low standard deviation has returns that are closer to the average of the set.  Note that even if the overall portfolio standard deviation increases with the inclusion of an indexed annuity, an indexed annuity may serve to reduce risk for the distribution of wealth outcomes, as returns for the indexed annuity do not follow a traditional bell-shaped distribution."
                />
            );

            percentile90ToolTip = (
                <ToolTip
                    message="Represents consistently better than expected investment returns. Only 10% of the simulations ended in a cumulative value higher than this value, and 90% of the simulations resulted in a cumulative value lower than this value."
                />
            );

            percentile50ToolTip = (
                <ToolTip
                    message="Half of the simulations ended in a cumulative value higher than this value, and half resulted in a cumulative value lower than this value."
                />
            );

            percentile10ToolTip = (
                <ToolTip
                    message="Represents consistently worse than expected investment returns. Only 10% of the simulations ended in a cumulative value lower than this value, and 90% of the simulations resulted in a cumulative value higher than this value."
                />
            );

            sharpeRatioToolTip = (
                <ToolTip
                    message="Risk-adjusted return based on total standard deviation. Sharpe Ratio = 10-year average cumulative return / Standard deviation of the 10-year cumulative returns."
                />
            );

            sortinoRatioToolTip = (
                <ToolTip
                    includeHtmlTag={true}
                    message="Risk-adjusted return based on downside deviation only. 10-year average cumulative return / Standard deviation of the 10-year cumulative returns across simulations where the 10-year cumulative return is less than the compounded Sortino minimum acceptable return (MAR). <br/>Compounded Sortino MAR (as of 12/31/2025) = (1+ 3.12%)<sup>10</sup> - 1 = 35.97%"
                />
            );

            if (this.props.IP7AllocationInvalid) {
                validationMessage = (
                    <div className={classes.validateAllocationMsg}>
                        Allocations must add to 100%
                    </div>
                );
            }

            viewReportBtn = (
                <button onClick={this.viewReport} className={classes.calculateButton}>View Report</button>
            );

            conditionsInputs = (
                <div className={classes.conditionsContainer}>
                    <PageHeader title="Market Condition Assumptions"/>
                    <div className={classes.conditionsMessaging}>
                        <p>
                            Use the sliders to see how your portfolio will perform under different market conditions.
                            The market conditions will be applied to the first 3 years of the plan, and normal conditions
                            will be used for the last 7 years of the plan.
                        </p>
                        <p>
                            Changing the Equity conditions will change the expected returns for the US Equity,
                            International Equity and Alternatives asset classes. Changing the Interest Rate conditions
                            will change the expected returns for US and International Fixed Income asset classes.
                        </p>
                    </div>
                    <Conditions
                        updateState={this.updateMarketConditions}
                        isMarket={this.props.isMarket}
                        equity={this.props.equity}
                        interest={this.props.interest}
                    />
                    <button onClick={this.calculate} className={classes.calculateButton}>CALCULATE</button>
                </div>
            );

            if (!this.props.editMode) {
                editAllocationControls = (
                    <tr>
                        <td className="currentPlan"></td>
                        <td className="IP7Plan">
                            {validationMessage}
                            <button onClick={this.updateIP7EditMode}
                                    className={classes.editAllocationsButton}>Edit Allocations</button>

                        </td>
                    </tr>
                );
            } else {
                editAllocationControls = (
                    <tr>
                        <td className="currentPlan"></td>
                        <td className="IP7Plan">
                            {validationMessage}
                            <button onClick={this.cancelIP7Changes}
                                    className={classes.cancelAllocationsButton}>
                                Cancel
                            </button>
                            <button onClick={this.updateIP7EditMode}
                                    className={classes.saveAllocationsButton}>Save</button>
                        </td>
                    </tr>
                );
            }



        }

        if (this.props.displayMode) {
            informationalMessage = (
                <div className="compare-glossary-msg pageBreak">Please refer to the "Glossary" section below for information regarding the terms used on this page.</div>
            );
        }

        return (
            <div className="PlanOutput">
                <ScrollToTopOnMount />
                {instructionalText}
                <table>
                    <thead>
                    <tr>
                        <th className="blankHeader"></th>
                        <th className="headerLabel"><label>Current Portfolio</label></th>
                        <th className="headerLabel"><label>With {getIndexProtectorLabel(this.props.indexProtector)}</label></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="sideBar">
                            <div className="dataRow"><label>Beginning Portfolio Value</label></div>
                            <div className="dataRow tall"><h2>Statistical Highlights 10 Year Projections</h2></div>
                            <div className="dataRow"><label>Median Ending Portfolio Value</label></div>
                            <div className="dataRow"><label>Average Return</label></div>
                            <div className="dataRow">
                                <label>Standard Deviation</label>
                                {standardDevToolTip}
                            </div>
                            <div className="dataRow">
                                <label>Sharpe Ratio</label>
                                {sharpeRatioToolTip}
                            </div>
                            <div className="dataRow">
                                <label>Sortino Ratio</label>
                                {sortinoRatioToolTip}
                            </div>
                        </td>
                        <td className="currentPlan">
                            <PlanPortfolio portfolioInfo={this.props.standardPortfolioInfo}/>
                        </td>
                        <td className="IP7Plan">
                            <PlanPortfolio portfolioInfo={this.props.IP7PlanPortfolioInfo}/>
                        </td>
                    </tr>
                    <tr>
                        <td className="sideBar">
                            <div className="dataRow" style={{display: "inline-flex"}}>
                                {this.props.indexProtector.indexOf("INDEX ACHIEVER") === -1 && (
                                    <h2>3-Year Cumulative Wealth</h2>
                                )}
                                {this.props.indexProtector.indexOf("INDEX ACHIEVER") !== -1 && (
                                    <React.Fragment>
                                        <h2>6-Year Cumulative Wealth</h2>
                                        {sixYearCumulativeWealthToolTip}
                                    </React.Fragment>
                                )}
                            </div>
                            <div className="dataRow">
                                <label>90th Percentile</label>
                                {percentile90ToolTip}
                            </div>
                            <div className="dataRow">
                                <label>50th Percentile</label>
                                {percentile50ToolTip}
                            </div>
                            <div className="dataRow">
                                <label>10th Percentile</label>
                                {percentile10ToolTip}
                            </div>
                        </td>
                        <td className="currentPlan">
                            <PlanWealth wealth={this.props.standardWealthThreeYear}/>
                        </td>
                        <td className="IP7Plan">
                            <PlanWealth
                                wealth={this.props.IP7PlanWealthThreeYear}
                                showDifference="true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className="sideBar">
                            <div className="dataRow" style={{display: "inline-flex"}}>
                                {this.props.indexProtector.indexOf("INDEX ACHIEVER") === -1 && (
                                    <h2>10-Year Cumulative Wealth</h2>
                                )}
                                {this.props.indexProtector.indexOf("INDEX ACHIEVER") !== -1 && (
                                    <React.Fragment>
                                        <h2>10-Year Cumulative Wealth</h2>
                                        {tenYearCumulativeWealthToolTip}
                                    </React.Fragment>
                                )}
                            </div>
                            <div className="dataRow">
                                <label>90th Percentile</label>
                                {percentile90ToolTip}
                            </div>
                            <div className="dataRow">
                                <label>50th Percentile</label>
                                {percentile50ToolTip}
                            </div>
                            <div className="dataRow">
                                <label>10th Percentile</label>
                                {percentile10ToolTip}
                            </div>
                        </td>
                        <td className="currentPlan">
                            <PlanWealth wealth={this.props.standardWealth}/>
                        </td>
                        <td className="IP7Plan">
                            <PlanWealth
                                wealth={this.props.IP7PlanWealth}
                                showDifference="true"
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>

                {informationalMessage}
                <table className="pageBreak"></table>

                <table className="comparison-table pageBreak">
                    <thead>
                    <tr>
                        <th colSpan="2" className="headerLabel headerLabel-center"><label>Comparison</label></th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="currentPlan">
                                <PlanAllocation
                                    editMode={false}
                                    filterZero={this.props.displayMode}
                                    colors={this.props.colors}
                                    allocation={this.props.standardAllocation}
                                    hasIP7={false}
                                    graph={null}
                                    displayMode={this.props.displayMode}
                                    highlightIndex={-1}
                                    indexProtector={""}
                                />
                            </td>
                            <td className="IP7Plan">
                                <PlanAllocation
                                    updateAllocation={this.props.updateIP7Allocation}
                                    editMode={this.props.editMode}
                                    filterZero={this.props.displayMode}
                                    colors={this.props.colors}
                                    allocation={this.props.IP7Allocation}
                                    graph={this.props.graphAllocations}
                                    hasIP7={true}
                                    displayMode={this.props.displayMode}
                                    highlightIndex={3}
                                    indexProtector={this.props.indexProtector}
                                />
                            </td>
                        </tr>
                        {editAllocationControls}
                    </tbody>
                </table>
                {viewReportBtn}
                {conditionsInputs}
            </div>
        )
    };
}

const mapStateToProps = (state) => {

    return {
        standardPortfolioInfo: state.planOutputState.standardPlan.portfolioInfo,
        IP7PlanPortfolioInfo: state.planOutputState.IP7Plan.portfolioInfo,
        standardWealth: state.planOutputState.standardPlan.wealth,
        IP7PlanWealth: state.planOutputState.IP7Plan.wealth,
        standardWealthThreeYear: state.planOutputState.standardPlan.wealthThreeYear,
        IP7PlanWealthThreeYear: state.planOutputState.IP7Plan.wealthThreeYear,
        standardAllocation: state.planOutputState.standardPlan.allocation,
        IP7Allocation: state.planOutputState.IP7Plan.allocation,
        colors: state.planOutputState.colors,
        standardRisk: state.planOutputState.standardPlan.risk.risk,
        standardAnnualizedReturn: state.planOutputState.standardPlan.risk.annualizedReturn,
        IP7PlanRisk: state.planOutputState.IP7Plan.risk.risk,
        IP7PlanAnnualizedReturn: state.planOutputState.IP7Plan.risk.annualizedReturn,
        isMarket: state.planOutputState.conditions.isMarket,
        equity: state.planOutputState.conditions.equity,
        interest: state.planOutputState.conditions.interest,
        editMode: state.planOutputState.IP7Plan.allocation.editMode,
        IP7AllocationInvalid: state.planOutputState.IP7Plan.allocation.invalid,
        graphAllocations: state.planOutputState.backupAllocation,
        indexProtector: state.globalState.indexProtector
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateMarketConditionsType: (isMarket) => dispatch({
            type: actionTypes.UPDATE_MARKET_CONDITION_TYPE,
            isMarket: isMarket
        }),
        updateMenuState: () => dispatch({type: actionTypes.MENU_PLANCOMPARE}),
        setIP7EditMode: () => dispatch({type: actionTypes.SET_IP7_EDITABLE}),
        updateIP7Allocation: (data) => dispatch({type: actionTypes.UPDATE_IP7_ALLOCATION, data: data}),
        validateIP7Allocations: () => dispatch({type: actionTypes.VALIDATE_IP7_ALLOCATIONS}),
        clearPlanSubmit: () => dispatch({type: actionTypes.CLEAR_PLANINFO_SUBMITTED}),
        updateIP7PlanCalculations: () => dispatch(actionCreators.updateIP7PlanCalculations()),
        updateMarketRisk: () => dispatch(actionCreators.updateMarketRisk()),
        cancelIP7Changes: () => dispatch({type: actionTypes.CANCEL_IP7_ALLOCATION_CHANGE})
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanOutput);



// WEBPACK FOOTER //
// ./src/containers/PlanOutput/PlanOutput.js